import * as Sentry from "@sentry/react";

Sentry.init({
  environment: import.meta.env.VITE_NODE_ENV,
  dsn: "https://4e8c3341cac15f9b4d9b150b24df5b7e@o4509155304865792.ingest.us.sentry.io/4509166384119808",
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Debug mode in development
  debug: import.meta.env.VITE_NODE_ENV === "development",
});
